import React from 'react';
import { Multiselect } from 'AWS-UI-Components-React';
import { AccuracyButtonNewStyle } from '../../styles/common_styles';

export class ComponentsButton extends React.Component {

  getDropdownOptions = (components, selectedParentComponents) => {    
    return components.map((c) => {
      return {
        id: c.id,
        label: c.label,
        disabled:
          selectedParentComponents &&
          selectedParentComponents.length &&
          !selectedParentComponents.some((item) => c.id.startsWith(item)),
      };
    });
  };

  getSelectedParentComponents = () => {
    const { extractParentComponent, selected } = this.props;
    return [...new Set(selected.map((item) => extractParentComponent(item)))];
  };

  render() {
    const selectedParentComponents = this.getSelectedParentComponents();

    return (
      <div className={AccuracyButtonNewStyle}>
        <b> {this.props.text} </b>
        <Multiselect
          options={this.getDropdownOptions(this.props.components, selectedParentComponents)}
          filteringType="auto"
          placeholder={this.props.text}
          onChange={this.props.onChange}
          selectedIds={this.props.selected}
          statusType={!this.props.components ? 'loading' : 'finished'}
          loadingText="Loading components..."          
          data-cy={this.props['data-cy']}          
        />
      </div>
    );
  }

  static defaultProps = {
    'data-cy': 'component-button',
  };
}



// WEBPACK FOOTER //
// ./src/components/buttons/components_button.jsx